import * as XLSX from 'xlsx';

export const generateExcelReport = (titleDoc = 'Reporte', listData = [], isMaster = false, subtableColumns = []) => {

    try {

        //Titulo del documento
        const now = new Date().toLocaleDateString();

        // Agregar cabecera
        let sheetData = [];
        sheetData.push(['', '', `           Quro GPS    `]);
        sheetData.push(['', '', `       01 999-944-27-00  `]);
        sheetData.push(['', '', `    soporte@quro.com.mx `]);
        sheetData.push([`Fecha: ${now}`]);
        sheetData.push([`                                                                                                            ${titleDoc}`.toUpperCase()]);
        sheetData.push([]); // espacio

        // Agregar maestro-detalle
        if (isMaster) {
            listData.forEach((grupo, index) => {

                // Fila de maestro
                sheetData.push([
                    `${grupo.titulo}    |    Total Registros: ${grupo.detalles.length}`
                ]);

                // Encabezados de los detalles
                sheetData.push(subtableColumns);

                // Filas de detalles
                grupo.detalles.forEach(detalle => {
                    sheetData.push([
                        ...detalle
                    ]);
                });

                // Línea vacía entre grupos
                sheetData.push([]);
            });
        }
        else {

            // Columnas de la tabla
            sheetData.push(subtableColumns);

            //Filas de la tabla 
            listData.forEach((item, index) => {

                // Filas de detalles
                sheetData.push([
                    ...item
                ]);
            });

            // Línea vacía entre grupos
            sheetData.push([]);
        }

        // Crear hoja
        const ws = XLSX.utils.aoa_to_sheet(sheetData);

        //Agrupar los documentos 
        ws["!merges"] = [
            XLSX.utils.decode_range("A5:G5"),
        ];

        // Ajustar anchos de columna
        const colWidths = [];
        for (let i = 0; i < subtableColumns.length; i++) colWidths.push({ wch: 25 });
        ws['!cols'] = colWidths;

        // Crear libro
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Reporte");

        // Exportar
        XLSX.writeFile(wb, titleDoc.replace(' ', '_') + "_Excel.xlsx");

    } catch (error) {
        console.error("Error al exportar a Excel:", error);
    }
}